export default "__VITE_ASSET__CCrobGte__"